import { FC } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { AppHeaderMobile } from './AppHeaderMobile';
import LandingHeader from './LandingHeader';
import logo from '../../../assets/WaterVision_posi_yoko.png';
interface HeaderProps {
  user: any;
  onMenuClick?: () => void;
  isMenuOpen?: boolean;
}

export const Header: FC<HeaderProps> = ({
  user, onMenuClick, isMenuOpen
}) => {
  return (
    <AppBar position="fixed" color="inherit">
      <Toolbar style={{ minHeight: 60 }}>
        <Link className="navbar-brand" to={user ? '/app' : '/'} rel="noopener">
          <img
            src={logo}
            alt=""
            width="214"
            height="48"
            className="d-inline-block align-text-top"
          />
        </Link>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}></Typography>
        {!!user ? (
          <AppHeaderMobile user={user} onMenuClick={onMenuClick} isMenuOpen={isMenuOpen} />
        ) : (
          <LandingHeader />
        )}
      </Toolbar>
    </AppBar>
  );
};
